module.exports = __webpack_public_path__ + "img/play.0af8909f.svg";